<script>
import { mapActions, mapState } from 'vuex'
import CategoryInputs from './category-inputs'
import TierInputs from './tier-inputs'
import GroupInputs from './group-inputs'

export default {
  name: 'HierarchyTreeEditor',
  components: { CategoryInputs, TierInputs, GroupInputs },
  props: {
    value: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: 'groups',
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('category', ['tree']),
    showTiers() {
      return this.type && this.type !== 'categories'
    },
    showGroups() {
      return this.type && this.type === 'groups'
    },
  },
  methods: {
    ...mapActions('category', ['addItem']),
  },
}
</script>

<template>
  <div>
    <div :class="[$style.header, {[$style.viewMode]: viewMode}]">
      <div
        v-if="showGroups"
        :class="[$style.col, $style.headerGroup]"
      >
        <span>Product groups</span>
        <span
          v-if="type === 'groups' && !viewMode"
          :class="$style.addGroup"
          @click="addItem({ itemType: 'group' })"
        >+ Add Group</span>
      </div>
      <div
        v-if="showTiers"
        :class="[$style.col, $style.headerGroup]"
      >
        <span>Product Tiers</span>
      </div>
      <div :class="[$style.col, $style.headerGroup]">
        <span>Product Categories</span>
      </div>
    </div>

    <div
      v-if="type === 'categories'"
      :class="$style.categories"
    >
      <category-inputs
        v-model="tree"
        :view-mode="viewMode"
      />
    </div>

    <div
      v-if="type === 'tiers'"
      :class="$style.tiers"
    >
      <tier-inputs
        v-model="tree"
        :view-mode="viewMode"
      />
    </div>

    <div
      v-if="type === 'groups'"
      :class="$style.groups"
    >
      <group-inputs
        v-model="tree"
        :view-mode="viewMode"
      />
    </div>

    <div
      v-if="!viewMode"
      :class="$style.buttons"
    >
      <el-button
        type="primary"
        plain
        @click="$emit('cancel')"
      >
        Cancel
      </el-button>
      <el-button
        type="primary"
        @click="$emit('submit')"
      >
        Save
      </el-button>
    </div>
  </div>
</template>

<style lang="scss" module>
.header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 3rem;
  padding-right: var(--size-card-spacing);
  padding-left: var(--size-card-spacing);
  margin-right: calc(var(--size-card-spacing) * -1);
  margin-bottom: calc(var(--size-card-spacing) / 2) ;
  margin-left: calc(var(--size-card-spacing) * -1);
  font-weight: bold;
  background-color: var(--color-divider);
}

.col {
  min-width: rem(240px);
  margin-right: rem(36px);
}

.headerGroup {
  display: flex;
  justify-content: space-between;
}

.addGroup {
  grid-area: add;
  font-weight: bold;
  color: var(--color-primary);
  cursor: pointer;
}

.categories {
  display: flex;
}

.tiers {
  display: grid;
  grid-template-columns: 240px 240px;
  grid-column-gap: rem(36px);
}

.groups {
  display: grid;
}

.tier {
  height: 100%;
}

.buttons {
  margin-top: var(--size-card-spacing);
}

.viewMode {
  margin-top: 1rem;
}
</style>
